(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["yg-anchor-item"] && !Shopify.designMode) return;
  try {
    class YGAnchorItem extends HTMLElement {
      #observedSection = null;
      static observer = null;
      static sectionToItem = new Map();
      static isScroll = false;

      constructor() {
        super();
        this.itemClick = this.itemClick.bind(this);
        this.sections = null;
      }

      connectedCallback() {
        this.sections = document.querySelectorAll('#main .shopify-section');
        this.addEventListener('click', this.itemClick);

        const sectionNumber = Number(this.getAttribute('data-section-number') || 0);
        if (!this.sections?.length || !Number.isFinite(sectionNumber) || sectionNumber <= 0) return;

        const section = this.sections[sectionNumber - 1];
        if (!section) return;

        this.#observedSection = section;
        YGAnchorItem.#ensureObserver();
        YGAnchorItem.sectionToItem.set(section, this);
        YGAnchorItem.observer.observe(section);
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.itemClick);

        if (this.#observedSection && YGAnchorItem.observer) {
          YGAnchorItem.sectionToItem.delete(this.#observedSection);
          YGAnchorItem.observer.unobserve(this.#observedSection);
        }
      }

      static #ensureObserver() {
        if (YGAnchorItem.observer) return;

        YGAnchorItem.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) return;
              const item = YGAnchorItem.sectionToItem.get(entry.target);
              if (!YGAnchorItem.isScroll) {
                item && item.setActiveFromObserver();
              }
            });
          },
          {
            root: null,
            threshold: 0.01,
            rootMargin: '-20% 0px -70% 0px',
          }
        );
      }

      setActiveFromObserver() {
        let id = this.getAttribute('data-id');
        let $anchorList;
        if (id) {
          $anchorList = this.parentElement
            ? Array.from(document.querySelectorAll(`yg-anchor-item[data-id="${id}"]`))
            : [];
        } else {
          $anchorList = this.parentElement
            ? Array.from(this.parentElement.querySelectorAll('yg-anchor-item'))
            : [];
        }

        $anchorList.forEach((el, index) => {
          el.classList.toggle('active', el.getAttribute('data-section-number') === this.getAttribute('data-section-number'));

          if (el === this) {
            this.labelClick(index);
          }
        });

        document.dispatchEvent(new CustomEvent('YG:anchor-change', {
          bubbles: true,
        }));
      }

      labelClick(index) {
        // 添加新的活动状态
        const parent = this.parentElement;
        if (parent && this.isScrollable(parent)) {
          const containerRect = parent.getBoundingClientRect();
          const targetRect = this.getBoundingClientRect();
          const scrollLeft = targetRect.left - containerRect.left + parent.scrollLeft - 260;

          parent.scrollTo({
            left: scrollLeft,
            behavior: 'smooth',
          });
        }
      }

      isScrollable(el) {
        if (!el) return false;

        const style = window.getComputedStyle(el);
        const overflowY = style.overflowY;
        const overflowX = style.overflowX;

        const canScrollVertically =
          (overflowY === 'scroll' || overflowY === 'auto') && el.scrollHeight > el.clientHeight;
        const canScrollHorizontally =
          (overflowX === 'scroll' || overflowX === 'auto') && el.scrollWidth > el.clientWidth;

        return canScrollVertically || canScrollHorizontally;
      }

      itemClick() {
        const sectionNumber = this.getAttribute('data-section-number');
        YGAnchorItem.isScroll = true;
        this.setActiveFromObserver();
        if (sectionNumber == 0) {
          window.scrollTo({
            top: 0,
            behavior: 'smooth',
          });
        } else {
          const section = this.sections[sectionNumber - 1];
          if (!section) return;
          const offsetTop = section.getBoundingClientRect().top + window.pageYOffset - 100;
          window.scrollTo({ top: offsetTop, behavior: 'smooth' });
        }

        setTimeout(() => {
          YGAnchorItem.isScroll = false;
        }, 600);
      }
    }
    if (!window.customElements.get('yg-anchor-item')) {
      window.customElements.define('yg-anchor-item', YGAnchorItem);
    }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["yg-buy-now-button"] && !Shopify.designMode) return;
  try {
    if (!window.customElements.get('yg-buy-now-button')) {
    class YGBuyNowButton extends HTMLElement {
      connectedCallback() {
        if (this._initialized) {
          this._syncButtonState();
          return;
        }

        this._initialized = true;
        this._button = this.querySelector('button');
        if (this._button && !this._button.dataset.defaultLabel) {
          this._button.dataset.defaultLabel = this._button.textContent.trim();
        }
        this._productForm = document.forms[this.dataset.formId];
        this._productInfo = this.closest('.product-info') || document;
        this._onClick = this._onClick.bind(this);
        this._onVariantChange = this._onVariantChange.bind(this);
        this._onPartsChange = this._onPartsChange.bind(this);
        this._button?.addEventListener('click', this._onClick);
        this._productForm?.addEventListener('variant:change', this._onVariantChange);
        this._productInfo?.addEventListener('yg:product-parts:change', this._onPartsChange);
        this._syncButtonState();
      }

      disconnectedCallback() {
        this._button?.removeEventListener('click', this._onClick);
        this._productForm?.removeEventListener('variant:change', this._onVariantChange);
        this._productInfo?.removeEventListener('yg:product-parts:change', this._onPartsChange);
        this._initialized = false;
      }

      get graphqlUrl() {
        return `https://${Shopify.shop}/api/${this.dataset.apiVersion || '2026-01'}/graphql.json`;
      }

      async _onClick() {
        if (!this._button || this._button.disabled || !this._productForm) {
          return;
        }

        if (!this._productForm.checkValidity()) {
          this._productForm.reportValidity();
          return;
        }

        const lines = this._buildCheckoutLines();

        if (!lines.length) {
          return;
        }

        this._setBusy(true);

        try {
          const response = await fetch(this.graphqlUrl, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-Shopify-Storefront-Access-Token': this.dataset.storefrontApiKey,
            },
            body: JSON.stringify({
              query: `mutation YGBuyNowCreateCart($input: CartInput!) { cartCreate(input: $input) { cart { checkoutUrl } userErrors { field message } } }`,
              variables: {
                input: {
                  lines,
                },
              },
            }),
          });
          const json = await response.json();
          const topLevelErrors = Array.isArray(json.errors)
            ? json.errors.map((error) => error.message).filter(Boolean)
            : [];
          const userErrors = json.data?.cartCreate?.userErrors || [];
          const errorMessages = topLevelErrors.concat(userErrors.map((error) => error.message).filter(Boolean));

          if (!response.ok || errorMessages.length) {
            throw new Error(errorMessages.join(', ') || this.dataset.errorLabel || 'Unable to start checkout.');
          }

          const checkoutUrl = json.data?.cartCreate?.cart?.checkoutUrl;

          if (!checkoutUrl) {
            throw new Error(this.dataset.errorLabel || 'Unable to start checkout.');
          }

          window.location.href = checkoutUrl;
        } catch (error) {
          this._productForm.dispatchEvent(
            new CustomEvent('cart:error', {
              bubbles: true,
              detail: {
                error: error instanceof Error ? error.message : this.dataset.errorLabel || 'Unable to start checkout.',
              },
            })
          );
        } finally {
          this._setBusy(false);
        }
      }

      _onVariantChange(event) {
        this._currentVariant = event.detail?.variant || null;
        this._syncButtonState();
      }

      _onPartsChange() {
        this._syncButtonState();
      }

      _setBusy(isBusy) {
        if (!this._button) {
          return;
        }

        this._button.disabled = isBusy || !this._isVariantAvailable();
        this._button.toggleAttribute('aria-busy', isBusy);
        this._button.textContent = isBusy ? this.dataset.loadingLabel || 'Redirecting...' : this._getDefaultLabel();
      }

      _syncButtonState() {
        if (!this._button) {
          return;
        }

        this._button.disabled = !this._isVariantAvailable();
        this._button.textContent = this._getDefaultLabel();
      }

      _getDefaultLabel() {
        return this._button?.dataset.defaultLabel || this._button?.textContent?.trim() || 'Buy now';
      }

      _isVariantAvailable() {
        if (this._currentVariant && this._currentVariant.id) {
          return this._currentVariant.available !== false;
        }

        return this.dataset.variantAvailable === 'true' && !!this._getSelectedVariantId();
      }

      _buildCheckoutLines() {
        const formData = this._productForm ? new FormData(this._productForm) : null;
        const quantity = this._getQuantity(formData);
        const items = [
          {
            variantId: this._getSelectedVariantId(),
            quantity,
            attributes: this._getLineItemAttributes(formData),
            sellingPlanId: this._getSellingPlanId(formData),
          },
        ];
        const selectedParts = this._getSelectedParts();

        selectedParts.forEach((item) => {
          if (!item.available || !item.variantId) {
            return;
          }

          items.push({
            variantId: item.variantId,
            quantity: Number.parseInt(item.quantity || '1', 10) || 1,
          });
        });

        return Object.values(
          items.reduce((accumulator, item) => {
            if (!item.variantId || item.quantity <= 0) {
              return accumulator;
            }

            const key = JSON.stringify([String(item.variantId), item.sellingPlanId || '', item.attributes || []]);

            if (!accumulator[key]) {
              accumulator[key] = {
                merchandiseId: this._toGid(item.variantId),
                quantity: item.quantity,
              };

              if (item.attributes?.length) {
                accumulator[key].attributes = item.attributes;
              }

              if (item.sellingPlanId) {
                accumulator[key].sellingPlanId = item.sellingPlanId;
              }
            } else {
              accumulator[key].quantity += item.quantity;
            }

            return accumulator;
          }, {})
        );
      }

      _getSelectedParts() {
        const partsRoot = this.closest('.product-info')?.querySelector('yg-product-parts');

        if (partsRoot?.getSelectedItems) {
          return partsRoot.getSelectedItems();
        }

        return Array.from(partsRoot?.querySelectorAll('.yg-parts-item.is-selected') || [])
          .filter((item) => item.dataset.available !== 'false')
          .map((item) => ({
            variantId: item.dataset.variantId || '',
            available: item.dataset.available !== 'false',
            quantity: 1,
          }));
      }

      _getSelectedVariantId() {
        if (this._currentVariant?.id) {
          return String(this._currentVariant.id);
        }

        const variantInput = this._productForm?.querySelector('[name="id"]');
        return variantInput?.value ? String(variantInput.value) : '';
      }

      _getQuantity(formData) {
        const rawQuantity = formData?.get('quantity');
        const quantity = Number.parseInt(rawQuantity || '1', 10) || 1;
        return quantity > 0 ? quantity : 1;
      }

      _getLineItemAttributes(formData) {
        if (!formData) {
          return [];
        }

        const attributes = [];

        formData.forEach((value, key) => {
          if (!key.startsWith('properties[') || value === '' || value === null) {
            return;
          }

          const match = key.match(/^properties\[(.*)\]$/);

          if (!match || !match[1]) {
            return;
          }

          attributes.push({
            key: match[1],
            value: String(value),
          });
        });

        return attributes;
      }

      _getSellingPlanId(formData) {
        const value = formData?.get('selling_plan');
        return value ? String(value) : '';
      }

      _toGid(variantId) {
        const value = String(variantId || '');
        return value.indexOf('gid://') === 0 ? value : `gid://shopify/ProductVariant/${value}`;
      }
    }

    window.customElements.define('yg-buy-now-button', YGBuyNowButton);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["yg-collapse-button"] && !Shopify.designMode) return;
  try {
    class YGCollapseButton extends HTMLElement {
    #sectionEl;
    constructor() {
        super()
        this.itemClick = this.itemClick.bind(this)
    }

    get $sectionEl() {
      // if (this.#sectionEl) return this.#sectionEl

      this.#sectionEl = {
        'targetEl': document.querySelector(`.${this.getAttribute('data-target-class')}`),
        'buttonLabel': this.querySelector('.yg-link-label')
      }

      return this.#sectionEl
    }

    get collapsedHeight() {
      return Number(this.getAttribute('data-collapsed-height')) || 0
    }

    connectedCallback() {
        if (!this.$sectionEl['targetEl']) return
        this.init()
        this.addEventListener('click', this.itemClick);
        this.$sectionEl['targetEl'].addEventListener('click', ()=>{this.init()})
    }
    disconnectedCallback() {
        this.removeEventListener('click', this.itemClick);
    }

    init() {
      const target = this.$sectionEl['targetEl'];
      const buttonLabel = this.$sectionEl['buttonLabel'];

      if (!target.classList.contains('yg-collapse-target-el')) {
        target.classList.add('yg-collapse-target-el');
      }

      if (target.hasAttribute('open')) {
        target.style.height = 'auto';
        this.setAttribute('open', '');
        if (buttonLabel) {
          buttonLabel.innerText = this.getAttribute("data-less-label")
        }
      } else {
        target.style.height = `${this.collapsedHeight}px`;
        this.removeAttribute('open');
        if (buttonLabel) {
          buttonLabel.innerText = this.getAttribute("data-more-label")
        }
      }
    }

    openSection() {
      let target = this.$sectionEl['targetEl'];
      let buttonLabel = this.$sectionEl['buttonLabel'];

      // 先把高度设为当前像素值，再过渡到内容高度
      target.style.height = target.offsetHeight + 'px';
      
      // 强制浏览器重新计算一次布局，确保过渡生效
      target.offsetHeight;

      const endHeight = target.scrollHeight;
      target.style.height = endHeight + 'px';
      target.setAttribute('open', '');
      this.setAttribute('open', '');
      buttonLabel.innerText = this.getAttribute("data-less-label")

      const onTransitionEnd = (event) => {
        if (event.propertyName !== 'height') return;
        target.style.height = 'auto'; // 过渡结束后改为 auto，后续内容高度变化自动适应
        target.removeEventListener('transitionend', onTransitionEnd);
      };

      target.addEventListener('transitionend', onTransitionEnd);
    }

    closeSection() {
      const target = this.$sectionEl['targetEl'];
      const buttonLabel = this.$sectionEl['buttonLabel'];

      // 防止重复关闭
      if (!target.hasAttribute('open')) return;

      this.removeAttribute('open');
      buttonLabel.innerText = this.getAttribute("data-more-label")

      // 从 auto 变成具体高度，再过渡到 0
      if (getComputedStyle(target).height === 'auto') {
        target.style.height = target.scrollHeight + 'px';
      } else if (!target.style.height || target.style.height === `${this.collapsedHeight}px`) {
        target.removeAttribute('open');
        target.style.height = `${this.collapsedHeight}px`;
        return;
      }

      // 强制重新计算
      target.offsetHeight;

      target.style.height = `${this.collapsedHeight}px`;
      target.removeAttribute('open');
      this.removeAttribute('open');
      buttonLabel.innerText = this.getAttribute("data-more-label")
    }

    itemClick() {
      const target = this.$sectionEl['targetEl'];
      if (target.hasAttribute('open')) {
        this.closeSection();
      } else {
        this.openSection();
      }
    }
  }
  if (!window.customElements.get('yg-collapse-button')) {
    window.customElements.define('yg-collapse-button', YGCollapseButton)
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["yg-count-down"] && !Shopify.designMode) return;
  try {
    class YGCountDown extends HTMLElement {
    constructor() {
      super();
      this.timer = null;
      this.hasExpired = false;
    }

    connectedCallback() {
      this.targetDate = this.parseDate(this.dataset.date);

      if (!this.targetDate) {
        this.hidden = true;
        return;
      }

      this.updateCountdown();

      if (!this.hasExpired) {
        this.timer = window.setInterval(() => this.updateCountdown(), 1000);
      }
    }

    disconnectedCallback() {
      this.clearTimer();
    }

    parseDate(rawDate) {
      if (!rawDate) return null;

      const normalizedDate = rawDate.includes('T') ? rawDate : rawDate.replace(/-/g, '/');
      const parsedDate = new Date(normalizedDate);

      return Number.isNaN(parsedDate.getTime()) ? null : parsedDate;
    }

    clearTimer() {
      if (!this.timer) return;

      window.clearInterval(this.timer);
      this.timer = null;
    }

    get itemMap() {
      if (this._itemMap) return this._itemMap;

      this._itemMap = {
        days: this.querySelector('[data-unit="days"]'),
        hours: this.querySelector('[data-unit="hours"]'),
        minutes: this.querySelector('[data-unit="minutes"]'),
        seconds: this.querySelector('[data-unit="seconds"]')
      };

      return this._itemMap;
    }

    updateCountdown() {
      const diff = this.targetDate.getTime() - Date.now();

      if (diff <= 0) {
        this.handleExpiration();
        return;
      }

      const totalSeconds = Math.floor(diff / 1000);
      const days = Math.floor(totalSeconds / 86400);
      const hours = Math.floor((totalSeconds % 86400) / 3600);
      const minutes = Math.floor((totalSeconds % 3600) / 60);
      const seconds = totalSeconds % 60;

      this.renderValue(this.itemMap.days, days);
      this.renderValue(this.itemMap.hours, hours);
      this.renderValue(this.itemMap.minutes, minutes);
      this.renderValue(this.itemMap.seconds, seconds);
    }

    renderValue(element, value) {
      if (!element) return;
      element.textContent = String(value).padStart(2, '0');
    }

    handleExpiration() {
      if (this.hasExpired) return;

      this.hasExpired = true;
      this.clearTimer();

      if (this.dataset.endAction === 'hide_block' && this.dataset.blockId) {
        this.dispatchEvent(
          new CustomEvent('yg:announcement-block-expired', {
            bubbles: true,
            detail: {
              blockId: this.dataset.blockId
            }
          })
        );
        return;
      }

      this.hidden = true;
    }
  }

  (() => {
    const boot = () => {
      if (!window.customElements.get('yg-count-down')) {
        window.customElements.define('yg-count-down', YGCountDown);
      }
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot, { once: true });
    } else {
      boot();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["yg-dropdown"] && !Shopify.designMode) return;
  try {
    class YGDropdown extends YGUtils {
      #dropdownGroup;
      #transitionCleanup;
      #resizeObserver;
      static #groupRegistry = new Map();

      constructor() {
          super()
          this.itemClick = this.itemClick.bind(this);
          this.handleResize = this.handleResize.bind(this);
          this.debouncedResize = this.debounce(this.handleResize, 100);
      }

      #manageGroupRegistry(action) {
        const groupID = this.dataset.group
        if (!groupID) return action === 'get' ? null : undefined

        switch (action) {
          case 'add':
            if (!YGDropdown.#groupRegistry.has(groupID)) {
              YGDropdown.#groupRegistry.set(groupID, new Set())
            }
            YGDropdown.#groupRegistry.get(groupID).add(this)
            break
          case 'remove':
            if (YGDropdown.#groupRegistry.has(groupID)) {
              YGDropdown.#groupRegistry.get(groupID).delete(this)
            }
            break
          case 'get':
            const groupDropdowns = YGDropdown.#groupRegistry.get(groupID)
            this.#dropdownGroup = groupDropdowns ? Array.from(groupDropdowns) : null
            return this.#dropdownGroup
        }
      }

      get dropdownGroup() {
        if (this.#dropdownGroup) return this.#dropdownGroup
        return this.#manageGroupRegistry('get')
      }

      get sectionsEl() {
        if (this._sectionsEl) return this._sectionsEl

        this._sectionsEl = {
          titleContainer: this.querySelector('.yg-dropdown-title-container'),
          contentContainer: this.querySelector('.yg-dropdown-content-container'),
          content: this.querySelector('.yg-dropdown-content')
        }

        return this._sectionsEl
      }

      connectedCallback() {
          this.#manageGroupRegistry('add')

          setTimeout(() => {
            this.initDropdownState()
          }, 60);
          if (this.sectionsEl.titleContainer) {
            this.sectionsEl.titleContainer.addEventListener('click', this.itemClick);
          }
          window.addEventListener('resize', this.debouncedResize);
          this.observeContentResize();
          this.setContentContainerHeight({ immediate: true });
      }

      disconnectedCallback() {
          this.#manageGroupRegistry('remove')

          if (this.sectionsEl.titleContainer) {
            this.sectionsEl.titleContainer.removeEventListener('click', this.itemClick);
          }
          window.removeEventListener('resize', this.debouncedResize);
          if (this.#resizeObserver) {
            this.#resizeObserver.disconnect();
            this.#resizeObserver = null;
          }
          this.clearTransitionCleanup();
      }

      observeContentResize() {
        const content = this.sectionsEl.content
        if (!content || typeof ResizeObserver === 'undefined') return

        if (this.#resizeObserver) {
          this.#resizeObserver.disconnect();
        }

        this.#resizeObserver = new ResizeObserver(() => {
          const contentContainer = this.sectionsEl.contentContainer
          if (!contentContainer || !this.hasAttribute('open')) return

          if (contentContainer.style.height && contentContainer.style.height !== 'auto') {
            contentContainer.style.height = `${content.scrollHeight}px`
          }
        });

        this.#resizeObserver.observe(content)
      }

      clearTransitionCleanup() {
        if (typeof this.#transitionCleanup === 'function') {
          this.#transitionCleanup();
        }
        this.#transitionCleanup = null;
      }

      registerTransitionCleanup(callback) {
        const contentContainer = this.sectionsEl.contentContainer
        if (!contentContainer) return

        this.clearTransitionCleanup()

        const handleTransitionEnd = (event) => {
          if (event.target !== contentContainer || event.propertyName !== 'height') return
          callback?.()
          this.clearTransitionCleanup()
        }

        contentContainer.addEventListener('transitionend', handleTransitionEnd)
        this.#transitionCleanup = () => {
          contentContainer.removeEventListener('transitionend', handleTransitionEnd)
        }
      }

      initDropdownState() {
        const group = this.dropdownGroup

        if (!group || !Array.isArray(group) || group.length === 0) {
          this.setContentContainerHeight({ immediate: true })
          return
        }

        if (group[0] !== this) return

        const openedDropdown = group.find((dropdown) => dropdown.hasAttribute('open'))
        const activeDropdown = openedDropdown || group[0]

        group.forEach((dropdown) => {
          if (dropdown === activeDropdown) {
            dropdown.openDropdown({ skipGroup: true, immediate: true, shouldDispatch: true })
          } else {
            dropdown.closeDropdown({ immediate: true, shouldDispatch: true })
          }
        })
      }

      itemClick() {
          this.setContentContainerHeight();
          let group = this.dropdownGroup;
          if (group && Array.isArray(group) && this.hasAttribute('open')) {
            if (!this.hasAttribute('data-accordion') && group.length > 1) {
              this.closeDropdown();
            }
            return;
          }

          this.hasAttribute('open')?this.closeDropdown():this.openDropdown();
      }

      handleResize() {
        this.setContentContainerHeight({ immediate: true });
      }

      setContentContainerHeight({ immediate = false } = {}) {
        const contentContainer = this.sectionsEl.contentContainer
        const content = this.sectionsEl.content
        if (!contentContainer || !content) return

        if (!this.hasAttribute('open')) {
          contentContainer.style.height = '0px'
          return
        }

        if (immediate) {
          contentContainer.style.height = 'auto'
          return
        }

        if (contentContainer.style.height !== 'auto') {
          contentContainer.style.height = `${content.scrollHeight}px`
        }
      }

      openDropdown({ skipGroup = false, immediate = false, shouldDispatch = true } = {}){
        const contentContainer = this.sectionsEl.contentContainer
        const content = this.sectionsEl.content
        if (!contentContainer || !content) return

        let group = this.dropdownGroup;
        if (!skipGroup && group && Array.isArray(group)) {
            group.forEach(dropdown => {
                if (dropdown !== this) {
                    dropdown.closeDropdown({ shouldDispatch: false });
                }
            });
        }

        this.setAttribute('open', '');

        if (immediate) {
          contentContainer.style.height = 'auto'
        } else {
          this.clearTransitionCleanup()
          const startHeight = contentContainer.style.height === 'auto' ? content.scrollHeight : contentContainer.offsetHeight
          contentContainer.style.height = `${startHeight}px`
          contentContainer.offsetHeight
          contentContainer.style.height = `${content.scrollHeight}px`

          this.registerTransitionCleanup(() => {
            if (this.hasAttribute('open')) {
              contentContainer.style.height = 'auto'
            }
          })
        }

        if (shouldDispatch) {
          document.dispatchEvent(new CustomEvent('YG:dropdown-open', {
            bubbles: true,
            composed: true,
            detail: {
              id: this.getAttribute('data-id')
            }
          }));
        }
      }

      closeDropdown({ immediate = false, shouldDispatch = true } = {}){
        const contentContainer = this.sectionsEl.contentContainer
        const content = this.sectionsEl.content
        if (!contentContainer || !content) return
        if (!this.hasAttribute('open') && !immediate) return

        this.clearTransitionCleanup()

        if (immediate) {
          this.removeAttribute('open');
          contentContainer.style.height = '0px'
          return
        }

        const currentHeight = contentContainer.style.height === 'auto' ? content.scrollHeight : contentContainer.offsetHeight
        contentContainer.style.height = `${currentHeight}px`

        contentContainer.offsetHeight
        this.removeAttribute('open');
        contentContainer.style.height = '0px'

        if (shouldDispatch) {
          document.dispatchEvent(new CustomEvent('YG:dropdown-close', {
            bubbles: true,
            composed: true,
            detail: {
              id: this.getAttribute('data-id')
            }
          }));
        }
      }
  }
  if (!window.customElements.get('yg-dropdown')) {
      window.customElements.define('yg-dropdown',YGDropdown)
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["yg-image"] && !Shopify.designMode) return;
  try {
    class YGImage extends YGImageLazyLoader {
    constructor() {
      super();
    }
    connectedCallback() {
      this.loaderImg();
    }
    get images() {
      return this.querySelectorAll('img[data-src]');
    }

    loaderImg() {
      // 这里放置自定义逻辑
      this.images.forEach((img) => {
        // 安全检查，确保 YGUtils 已加载
        if (this.getLazyLoader) {
          this.getLazyLoader().observe(img);
        } else {
          console.warn('YGUtils 未加载，使用备用图片加载方式');
          // 备用方案：直接设置图片源
          if (img.getAttribute('data-src')) {
            img.src = img.getAttribute('data-src');
            img.removeAttribute('data-src');
          }
        }
      });
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    if (!window.customElements.get('yg-image')) {
      window.customElements.define('yg-image', YGImage);
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["yg-mega-menu-horizontal"] && !Shopify.designMode) return;
  try {
    class YGMegaMenuHorizontal extends HTMLElement {
    constructor() {
      super();
      this.tabItems = [];
      this.tabContents = [];
      this.closeButtons = [];
      this.handleTabHover = this.handleTabHover.bind(this);
      this.handleTabFocus = this.handleTabFocus.bind(this);
      this.handleTabClick = this.handleTabClick.bind(this);
      this.handleTabKeydown = this.handleTabKeydown.bind(this);
      this.handleCloseClick = this.handleCloseClick.bind(this);
      this.handleCloseKeydown = this.handleCloseKeydown.bind(this);
    }

    connectedCallback() {
      this.tabItems = Array.from(this.querySelectorAll('.yg-menu-tabs-item'));
      this.tabContents = Array.from(this.querySelectorAll('.yg-menu-tabs-content'));
      this.closeButtons = Array.from(this.querySelectorAll('.yg-menu-close'));

      this.closeButtons.forEach((closeButton) => {
        closeButton.tabIndex = 0;
        closeButton.setAttribute('role', 'button');
        closeButton.setAttribute('aria-label', 'Close menu');
        closeButton.addEventListener('click', this.handleCloseClick);
        closeButton.addEventListener('keydown', this.handleCloseKeydown);
      });

      if (this.tabItems.length === 0 || this.tabContents.length === 0) {
        return;
      }

      this.tabItems.forEach((tabItem) => {
        tabItem.tabIndex = 0;
        tabItem.setAttribute('role', 'button');
        tabItem.addEventListener('mouseenter', this.handleTabHover);
        tabItem.addEventListener('focus', this.handleTabFocus);
        tabItem.addEventListener('click', this.handleTabClick);
        tabItem.addEventListener('keydown', this.handleTabKeydown);
      });

      const activeTab = this.querySelector('.yg-menu-tabs-item.active') || this.tabItems[0];
      this.setActiveTab(activeTab.dataset.index);
    }

    disconnectedCallback() {
      this.tabItems.forEach((tabItem) => {
        tabItem.removeEventListener('mouseenter', this.handleTabHover);
        tabItem.removeEventListener('focus', this.handleTabFocus);
        tabItem.removeEventListener('click', this.handleTabClick);
        tabItem.removeEventListener('keydown', this.handleTabKeydown);
      });

      this.closeButtons.forEach((closeButton) => {
        closeButton.removeEventListener('click', this.handleCloseClick);
        closeButton.removeEventListener('keydown', this.handleCloseKeydown);
      });
    }

    handleTabHover(event) {
      this.setActiveTab(event.currentTarget.dataset.index);
    }

    handleTabFocus(event) {
      this.setActiveTab(event.currentTarget.dataset.index);
    }

    handleTabClick(event) {
      this.setActiveTab(event.currentTarget.dataset.index);
    }

    handleTabKeydown(event) {
      if (event.key !== 'Enter' && event.key !== ' ') {
        return;
      }

      event.preventDefault();
      this.setActiveTab(event.currentTarget.dataset.index);
    }

    handleCloseClick(event) {
      event.preventDefault();
      event.stopPropagation();
      this.closeMegaMenu();
    }

    handleCloseKeydown(event) {
      if (event.key !== 'Enter' && event.key !== ' ') {
        return;
      }

      event.preventDefault();
      event.stopPropagation();
      this.closeMegaMenu();
    }

    closeMegaMenu() {
      const menuDisclosure = this.closest('details[is="mega-menu-disclosure"]') || this.closest('details[open]');

      if (menuDisclosure) {
        menuDisclosure.open = false;
      }
    }

    setActiveTab(index) {
      if (!index) {
        return;
      }

      this.tabItems.forEach((tabItem) => {
        const isActive = tabItem.dataset.index === index;
        tabItem.classList.toggle('active', isActive);
        tabItem.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });

      this.tabContents.forEach((tabContent) => {
        const isActive = tabContent.dataset.index === index;
        tabContent.classList.toggle('active', isActive);
        tabContent.setAttribute('aria-hidden', isActive ? 'false' : 'true');
      });
    }
  }

  if (!window.customElements.get('yg-mega-menu-horizontal')) {
    window.customElements.define('yg-mega-menu-horizontal', YGMegaMenuHorizontal);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["yg-open-popup"] && !Shopify.designMode) return;
  try {
    class YGOpenPopup extends HTMLElement {
    constructor() {
      super();
      this.handleActivate = this.handleActivate.bind(this);
      this.handleKeydown = this.handleKeydown.bind(this);
    }

    getDirectPopupTemplate() {
      return Array.from(this.children).find((child) => child.matches('template, .yg-popup-template')) || null;
    }

    connectedCallback() {
      this.sectionsEl = {
        popupTemplate: this.getDirectPopupTemplate(),
      };

      if (!this.hasAttribute('role')) {
        this.setAttribute('role', 'button');
      }

      if (!this.hasAttribute('tabindex')) {
        this.setAttribute('tabindex', '0');
      }

      this.addEventListener('click', this.handleActivate);
      this.addEventListener('keydown', this.handleKeydown);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.handleActivate);
      this.removeEventListener('keydown', this.handleKeydown);
    }

    getPopupTemplate() {
      if (this.sectionsEl.popupTemplate) {
        return this.sectionsEl.popupTemplate;
      }

      if (!this.dataset.popupId) {
        return null;
      }

      return document.getElementById(`yg-popup-template-${this.dataset.popupId}`);
    }

    handleKeydown(event) {
      if (event.key !== 'Enter' && event.key !== ' ') {
        return;
      }

      event.preventDefault();
      this.handleActivate();
    }

    handleActivate() {
      const popupTemplate = this.getPopupTemplate();

      if (!popupTemplate) {
        console.error('popupTemplate is missing');
        return;
      }

      this.dispatchEvent(
        new CustomEvent('YG:openPopup', {
          bubbles: true,
          detail: {
            popupTemplate,
            popupClass: this.dataset.popupClass,
            closeBtnClass: this.dataset.closeBtnClass,
          },
        })
      );
    }
  }
  if (!window.customElements.get('yg-open-popup')) {
    window.customElements.define('yg-open-popup', YGOpenPopup);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["yg-popup"] && !Shopify.designMode) return;
  try {
    class YGPopupBox extends HTMLElement {
    constructor() {
      super();
      this.closePopup = this.closePopup.bind(this);
      this.openPopup = this.openPopup.bind(this);
    }

    // 优化：缓存并懒加载元素，只查询一次，提高性能和可维护性
    get sectionsEl() {
      if (this._sectionsEl) return this._sectionsEl;

      this._sectionsEl = {
        'close': this.querySelector('.yg-popup-box-close'),
        'content-inner': this.querySelector('.yg-popup-box-content-inner'),
        'body': document.body,
      };
      
      return this._sectionsEl;
    }

    connectedCallback() {
      this.addEventListener('click', this.closePopup);
      document.addEventListener('YG:openPopup', this.openPopup);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.closePopup);
      document.removeEventListener('YG:openPopup', this.openPopup);
    }

    openPopup(e) {
      const { popupTemplate, popupClass, closeBtnClass } = e.detail || {};
      
      if (!popupTemplate) {
        console.error('popupTemplate is missing');
        return;
      }
      // popupTemplate：需要替换的元素
      this.sectionsEl['close'].classList.add(`${closeBtnClass}`)
      this.classList.add(`${popupClass}`)
      this.sectionsEl['content-inner'].innerHTML = popupTemplate.innerHTML;
      this.sectionsEl['body'].style.overflow = 'hidden';
      this.style.display = 'flex';
    }

    closePopup(e) {
      const closeBtn = e.target.closest('.yg-popup-box-close');
      const popupBox = e.target.closest('.yg-popup-box');
      if (closeBtn || (popupBox && e.target === popupBox)) {
        this.style.display = 'none';
        this.sectionsEl['content-inner'].innerHTML = '';
        this.sectionsEl['body'].style.overflow = 'auto';
        this.sectionsEl['close'].className = 'yg-popup-box-close';
        this.className = 'yg-popup-box';
      }
    } 
  }
  if (!window.customElements.get('yg-popup-box')) {
    window.customElements.define('yg-popup-box', YGPopupBox);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["yg-product-coupon-01"] && !Shopify.designMode) return;
  try {
    class YGProductCoupon01 extends HTMLElement {
    constructor() {
      super();
      this.handleExpiration = this.handleExpiration.bind(this);
    }

    connectedCallback() {
      this.addEventListener('yg:announcement-block-expired', this.handleExpiration);
      this.hideIfExpired();
    }

    disconnectedCallback() {
      this.removeEventListener('yg:announcement-block-expired', this.handleExpiration);
    }

    hideBlock() {
      const blockItem = this.closest('.product-info__block-item');

      if (blockItem) {
        blockItem.hidden = true;
        return;
      }

      this.hidden = true;
    }

    hideIfExpired() {
      const countdown = this.querySelector('yg-count-down[data-date][data-end-action="hide_block"]');
      if (!countdown) return;

      const rawDate = countdown.dataset.date;
      const normalizedDate = rawDate.includes('T') ? rawDate : rawDate.replace(/-/g, '/');
      const targetDate = new Date(normalizedDate);

      if (!Number.isNaN(targetDate.getTime()) && targetDate.getTime() <= Date.now()) {
        this.hideBlock();
      }
    }

    handleExpiration(event) {
      if (!event.detail || !event.detail.blockId || this.dataset.blockId !== event.detail.blockId) return;

      this.hideBlock();
    }
  }

  if (!window.customElements.get('yg-product-coupon-01')) {
    window.customElements.define('yg-product-coupon-01', YGProductCoupon01);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["yg-product-coupon-code-01"] && !Shopify.designMode) return;
  try {
    class YGProductCouponCode01 extends HTMLElement {
    constructor() {
      super();
      this.copyTimeout = null;
      this.handleClick = this.handleClick.bind(this);
    }

    connectedCallback() {
      this.copyTrigger = this.querySelector('[data-copy-trigger]');
      this.statusElement = this.querySelector('[data-copy-status]');

      if (this.copyTrigger) {
        this.copyTrigger.addEventListener('click', this.handleClick);
      }

      this.labelElement = this.querySelector('.yg-product-coupon-code-01__label');
      this.defaultLabel = this.labelElement ? this.labelElement.textContent : '';
    }

    disconnectedCallback() {
      if (this.copyTrigger) {
        this.copyTrigger.removeEventListener('click', this.handleClick);
      }

      if (this.copyTimeout) {
        window.clearTimeout(this.copyTimeout);
      }
    }

    async handleClick() {
      if (!this.dataset.discountCode) {
        this.showFeedback(this.dataset.copyErrorText || 'Copy failed');
        return;
      }

      const copied = await this.copyText(this.dataset.discountCode);

      if (copied) {
        this.showFeedback(this.dataset.copySuccessText || 'Copied', true);
        return;
      }

      this.showFeedback(this.dataset.copyErrorText || 'Copy failed');
    }

    async copyText(value) {
      if (navigator.clipboard && window.isSecureContext) {
        try {
          await navigator.clipboard.writeText(value);
          return true;
        } catch (error) {
        }
      }

      const textarea = document.createElement('textarea');
      textarea.value = value;
      textarea.setAttribute('readonly', '');
      textarea.style.position = 'fixed';
      textarea.style.opacity = '0';
      textarea.style.pointerEvents = 'none';

      document.body.appendChild(textarea);
      textarea.select();
      textarea.setSelectionRange(0, textarea.value.length);

      const copied = document.execCommand('copy');
      document.body.removeChild(textarea);

      return copied;
    }

    showFeedback(message, copied = false) {
      if (this.copyTimeout) {
        window.clearTimeout(this.copyTimeout);
      }

      if (this.labelElement) {
        this.labelElement.textContent = message;
      }

      if (this.statusElement) {
        this.statusElement.textContent = message;
      }

      if (copied) {
        this.dataset.copied = 'true';
      } else {
        this.removeAttribute('data-copied');
      }

      this.copyTimeout = window.setTimeout(() => {
        if (this.labelElement) {
          this.labelElement.textContent = this.defaultLabel;
        }

        if (this.statusElement) {
          this.statusElement.textContent = '';
        }

        this.removeAttribute('data-copied');
      }, 3000);
    }
  }

  if (!window.customElements.get('yg-product-coupon-code-01')) {
    window.customElements.define('yg-product-coupon-code-01', YGProductCouponCode01);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["yg-product-parts"] && !Shopify.designMode) return;
  try {
    window.__ygProductPartsFormatMoney = window.__ygProductPartsFormatMoney || function(cents, format) {
    const moneyFormat = format || window.themeVariables?.settings?.moneyFormat || '__amount__';
    const amount = Number(cents) || 0;

    const formatWithDelimiters = (number, precision = 2, thousands = ',', decimal = '.') => {
      const value = (number / 100).toFixed(precision);
      const parts = value.split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return parts[1] ? parts.join(decimal) : parts[0];
    };

    const placeholderMatch = moneyFormat.match(/\{\{\s*(\w+)\s*\}\}|__(\w+)__/);
    const placeholder = placeholderMatch ? placeholderMatch[1] || placeholderMatch[2] : 'amount';
    let value = '';

    switch (placeholder) {
      case 'amount':
        value = formatWithDelimiters(amount, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(amount, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(amount, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(amount, 0, '.', ',');
        break;
      case 'amount_with_space_separator':
        value = formatWithDelimiters(amount, 2, ' ', '.');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(amount, 0, ' ', '.');
        break;
      case 'amount_with_apostrophe_separator':
        value = formatWithDelimiters(amount, 2, "'", '.');
        break;
      default:
        value = formatWithDelimiters(amount, 2);
    }

    return moneyFormat.replace(/\{\{\s*\w+\s*\}\}|__\w+__/, value).trim();
  };

  if (!window.customElements.get('yg-product-parts')) {
    class YGProductParts extends HTMLElement {
      connectedCallback() {
        if (this._initialized) {
          this._refreshCollapseState();
          return;
        }

        this._initialized = true;
        this._onClick = this._onClick.bind(this);
        this._onChange = this._onChange.bind(this);
        this._onInput = this._onInput.bind(this);
        this._onResize = this._onResize.bind(this);
        this.addEventListener('click', this._onClick);
        this.addEventListener('change', this._onChange);
        this.addEventListener('input', this._onInput);
        window.addEventListener('resize', this._onResize);
        this._initializeItems();
        this._refreshCollapseState();
        this._emitSelectionChange();
      }

      disconnectedCallback() {
        this.removeEventListener('click', this._onClick);
        this.removeEventListener('change', this._onChange);
        this.removeEventListener('input', this._onInput);
        window.removeEventListener('resize', this._onResize);
        this._initialized = false;
      }

      getSelectedItems() {
        return this._getSelectedItems().map((item) => this._serializeItem(item));
      }

      getSelectedPartsPrice() {
        return this._getSelectedItems().reduce((total, item) => {
          return total + this._toNumber(item.dataset.price) * this._getItemQuantity(item);
        }, 0);
      }

      _initializeItems() {
        this._getItems().forEach((item) => {
          this._syncItemVariant(item, false);
          this._updateToggleLabel(item);
        });
      }

      _onClick(event) {
        const swatch = event.target.closest('[data-option-swatch]');

        if (swatch && this.contains(swatch)) {
          this._handleSwatchClick(swatch);
          return;
        }

        const toggleButton = event.target.closest('[data-toggle-button]');

        if (toggleButton && this.contains(toggleButton)) {
          this._handleToggleClick(toggleButton);
        }
      }

      _onChange(event) {
        const target = event.target;

        if (!(target instanceof HTMLElement)) {
          return;
        }

        if (target.matches('[data-option-select]')) {
          const item = target.closest('.yg-parts-item');

          if (item) {
            this._syncItemVariant(item);
            this._refreshCollapseState();
          }

          return;
        }

        if (target.matches('[data-part-quantity]')) {
          this._handleQuantityChange(target.closest('.yg-parts-item'));
        }
      }

      _onInput(event) {
        const target = event.target;

        if (target instanceof HTMLElement && target.matches('[data-part-quantity]')) {
          this._handleQuantityChange(target.closest('.yg-parts-item'));
        }
      }

      _onResize() {
        this._refreshCollapseState();
      }

      _handleSwatchClick(swatch) {
        const item = swatch.closest('.yg-parts-item');
        const group = swatch.closest('[data-option-swatch-group]');

        if (!item || !group) {
          return;
        }

        group.querySelectorAll('[data-option-swatch]').forEach((button) => {
          button.classList.remove('is-active');
          button.setAttribute('aria-pressed', 'false');
        });

        swatch.classList.add('is-active');
        swatch.setAttribute('aria-pressed', 'true');
        this._syncItemVariant(item);
      }

      _handleToggleClick(toggleButton) {
        const item = toggleButton.closest('.yg-parts-item');

        if (!item || item.dataset.available === 'false') {
          return;
        }

        const nextSelected = item.dataset.selected !== 'true';
        this._setItemSelected(item, nextSelected);
      }

      _handleQuantityChange(item) {
        if (!item) {
          return;
        }

        const quantityInput = item.querySelector('[data-part-quantity]');

        if (!quantityInput || quantityInput.value === '') {
          return;
        }

        if (item.dataset.selected === 'true') {
          this._emitSelectionChange();
        }
      }

      _syncItemVariant(item, shouldEmit = true) {
        const variants = this._getVariants(item);

        if (!variants.length) {
          return;
        }

        const matchedVariant = this._findMatchingVariant(item, variants) || variants.find((variant) => String(variant.id) === String(item.dataset.variantId)) || variants[0];

        if (!matchedVariant) {
          item.dataset.available = 'false';
          item.dataset.variantId = '';
          item.classList.add('is-soldout');
          this._setItemSelected(item, false, false);
          item.querySelector('[data-toggle-button]')?.setAttribute('disabled', '');
          this._updateToggleLabel(item);

          if (shouldEmit) {
            this._emitSelectionChange();
          }

          return;
        }

        item.dataset.variantId = String(matchedVariant.id || '');
        item.dataset.price = String(this._toNumber(matchedVariant.price));
        item.dataset.comparePrice = String(this._toNumber(matchedVariant.compare_at_price));
        item.dataset.available = matchedVariant.available === false ? 'false' : 'true';
        item.classList.toggle('is-soldout', item.dataset.available === 'false');
        item.querySelector('[data-toggle-button]')?.toggleAttribute('disabled', item.dataset.available === 'false');

        if (item.dataset.available === 'false' && item.dataset.selected === 'true') {
          this._setItemSelected(item, false, false);
        }

        this._updateItemPrice(item);
        this._updateToggleLabel(item);

        if (shouldEmit) {
          this._emitSelectionChange();
        }
      }

      _refreshCollapseState() {
        const collapseButton = this.querySelector('yg-collapse-button');
        const content = this.querySelector('[data-parts-list]');
        const items = this._getItems();
        const showLimit = this._getShowLimit();

        if (!collapseButton || !content || items.length <= showLimit) {
          return;
        }

        requestAnimationFrame(() => {
          const collapsedHeight = this._getCollapsedHeight(items, showLimit);

          if (!collapsedHeight) {
            return;
          }

          collapseButton.setAttribute('data-collapsed-height', String(collapsedHeight));

          if (!content.hasAttribute('open')) {
            content.style.height = `${collapsedHeight}px`;
          }

          if (typeof collapseButton.init === 'function') {
            collapseButton.init();
          }
        });
      }

      _getCollapsedHeight(items, showLimit) {
        if (!items.length) {
          return 0;
        }

        const visibleItems = items.slice(0, showLimit);
        const firstItem = visibleItems[0];
        const lastItem = visibleItems[visibleItems.length - 1];

        if (!firstItem || !lastItem) {
          return 0;
        }

        return Math.ceil(lastItem.offsetTop + lastItem.offsetHeight - firstItem.offsetTop);
      }

      _getItems() {
        return Array.from(this.querySelectorAll('.yg-parts-item'));
      }

      _getVariants(item) {
        if (item._ygVariants) {
          return item._ygVariants;
        }

        const script = item.querySelector('[data-part-variants]');

        if (!script) {
          item._ygVariants = [];
          return item._ygVariants;
        }

        try {
          item._ygVariants = JSON.parse(script.textContent.trim());
        } catch (error) {
          item._ygVariants = [];
        }

        return item._ygVariants;
      }

      _getSelectedItems() {
        return this._getItems().filter((item) => item.dataset.selected === 'true' && item.dataset.available !== 'false' && item.dataset.variantId);
      }

      _getSelectedOptionValues(item) {
        return Array.from(item.querySelectorAll('[data-option-group]')).reduce((selectedOptions, group) => {
          const position = Number(group.dataset.optionPosition || '0');

          if (!position) {
            return selectedOptions;
          }

          const activeSwatch = group.querySelector('[data-option-swatch].is-active');
          const select = group.querySelector('[data-option-select]');

          if (activeSwatch) {
            selectedOptions.set(position, activeSwatch.dataset.optionValue || '');
          } else if (select) {
            selectedOptions.set(position, select.value || '');
          }

          return selectedOptions;
        }, new Map());
      }

      _findMatchingVariant(item, variants) {
        const selectedOptions = this._getSelectedOptionValues(item);

        if (!selectedOptions.size) {
          return variants.find((variant) => String(variant.id) === String(item.dataset.variantId)) || null;
        }

        return variants.find((variant) => {
          const optionValues = Array.isArray(variant.options) ? variant.options : [variant.option1, variant.option2, variant.option3];

          return Array.from(selectedOptions.entries()).every(([position, value]) => {
            return String(optionValues[position - 1] || '') === String(value || '');
          });
        }) || null;
      }

      _setItemSelected(item, isSelected, shouldEmit = true) {
        item.dataset.selected = isSelected ? 'true' : 'false';
        item.classList.toggle('is-selected', isSelected);
        this._updateToggleLabel(item);

        if (shouldEmit) {
          this._emitSelectionChange();
        }
      }

      _updateToggleLabel(item) {
        const toggleButton = item.querySelector('[data-toggle-button]');

        if (!toggleButton) {
          return;
        }

        toggleButton.textContent = item.dataset.selected === 'true'
          ? this.dataset.removeLabel || 'Remove'
          : this.dataset.addLabel || 'Add';
      }

      _updateItemPrice(item) {
        const priceElement = item.querySelector('[data-part-price]');
        const compareElement = item.querySelector('[data-part-compare-price]');
        const price = this._toNumber(item.dataset.price);
        const comparePrice = this._toNumber(item.dataset.comparePrice);

        if (priceElement) {
          priceElement.textContent = window.__ygProductPartsFormatMoney(price, this.dataset.moneyFormat);
        }

        if (!compareElement) {
          return;
        }

        if (comparePrice > price) {
          compareElement.hidden = false;
          compareElement.textContent = window.__ygProductPartsFormatMoney(comparePrice, this.dataset.moneyFormat);
        } else {
          compareElement.hidden = true;
          compareElement.textContent = '';
        }
      }

      _emitSelectionChange() {
        this.dispatchEvent(new CustomEvent('yg:product-parts:change', {
          bubbles: true,
          detail: {
            selectedItems: this.getSelectedItems(),
            selectedPartsPrice: this.getSelectedPartsPrice()
          }
        }));
      }

      _serializeItem(item) {
        return {
          available: item.dataset.available !== 'false',
          comparePrice: this._toNumber(item.dataset.comparePrice),
          price: this._toNumber(item.dataset.price),
          productId: item.dataset.productId || '',
          quantity: this._getItemQuantity(item),
          title: item.dataset.title || '',
          variantId: item.dataset.variantId || ''
        };
      }

      _getItemQuantity(item) {
        const quantityInput = item.querySelector('[data-part-quantity]');
        const quantity = Number.parseInt(quantityInput?.value || '1', 10) || 1;
        return quantity > 0 ? quantity : 1;
      }

      _getShowLimit() {
        return Number.parseInt(this.dataset.showLimit || '2', 10) || 2;
      }

      _toNumber(value) {
        return Number.parseInt(value || '0', 10) || 0;
      }
    }

    window.customElements.define('yg-product-parts', YGProductParts);
  }

  if (!window.customElements.get('yg-product-parts-total')) {
    class YGProductPartsTotal extends HTMLElement {
      connectedCallback() {
        if (this._initialized) {
          this.render();
          return;
        }

        this._initialized = true;
        this._productInfo = this.closest('.product-info') || document;
        this._partsRoot = this._productInfo.querySelector('yg-product-parts');
        this._priceElement = this.querySelector('[data-total-price]');
        this._handlePartsChange = this._handlePartsChange.bind(this);
        this._handleVariantChange = this._handleVariantChange.bind(this);
        this._handleQuantityEvent = this._handleQuantityEvent.bind(this);

        this._productInfo.addEventListener('yg:product-parts:change', this._handlePartsChange);
        this._productInfo.addEventListener('variant:change', this._handleVariantChange);
        this._productInfo.addEventListener('change', this._handleQuantityEvent);
        this._productInfo.addEventListener('input', this._handleQuantityEvent);
        this.render();
      }

      disconnectedCallback() {
        this._productInfo?.removeEventListener('yg:product-parts:change', this._handlePartsChange);
        this._productInfo?.removeEventListener('variant:change', this._handleVariantChange);
        this._productInfo?.removeEventListener('change', this._handleQuantityEvent);
        this._productInfo?.removeEventListener('input', this._handleQuantityEvent);
        this._initialized = false;
      }

      _handlePartsChange() {
        this.render();
      }

      _handleVariantChange(event) {
        const nextPrice = event.detail?.variant?.price;

        if (Number.isFinite(nextPrice)) {
          this.dataset.basePrice = String(nextPrice);
        }

        this.render();
      }

      _handleQuantityEvent(event) {
        const target = event.target;

        if (!(target instanceof HTMLInputElement) || target.name !== 'quantity') {
          return;
        }

        this.render();
      }

      render() {
        if (!this._priceElement) {
          return;
        }

        const totalPrice = this._getBasePrice() * this._getMainQuantity() + this._getPartsPrice();
        this._priceElement.textContent = window.__ygProductPartsFormatMoney(totalPrice, this.dataset.moneyFormat);
      }

      _getBasePrice() {
        return Number.parseInt(this.dataset.basePrice || '0', 10) || 0;
      }

      _getMainQuantity() {
        const quantityInput = this._productInfo.querySelector('.yg-buy-buttons-info-buttons input[name="quantity"], .product-info__quantity-selector input[name="quantity"]');
        const quantity = Number.parseInt(quantityInput?.value || '1', 10) || 1;
        return quantity > 0 ? quantity : 1;
      }

      _getPartsPrice() {
        this._partsRoot = this._partsRoot || this._productInfo.querySelector('yg-product-parts');
        return this._partsRoot?.getSelectedPartsPrice?.() || 0;
      }
    }

    window.customElements.define('yg-product-parts-total', YGProductPartsTotal);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["yg-progress-bar"] && !Shopify.designMode) return;
  try {
    class YGProgressBar extends HTMLElement {
    #videoListenersAttached = false;

    constructor() {
      super();
      this.video = null;
      this.animationFrame = null;
    }

    connectedCallback() {
    }

    get isCircle() {
      return this.classList.contains('yg-progress-circle');
    }

    get circleProgressElement() {
      return this.querySelector('.circle-progress');
    }

    findVideo() {
      let isMobile = window.innerWidth < 699;
      let id = this.getAttribute('data-id');
      if (isMobile && this.getAttribute('data-mobile-id')) {
        id = this.getAttribute('data-mobile-id');
      }
      if (!id) return null;

      return document.querySelector(`yg-video[data-id="${id}"]`);
    }

    getVideoElement(videoComponent) {
      if (!videoComponent) return null;
      return videoComponent.querySelector('.yg-video-iframe');
    }

    syncWithVideo() {
      if (!this.video) return;

      const videoEl = this.getVideoElement(this.video);
      if (!videoEl) return;

      const duration = this.video.duration || videoEl.duration || 0;
      const currentTime = videoEl.currentTime || 0;

      if (duration > 0) {
        const progress = (currentTime / duration) * 100;
        
        if (this.isCircle) {
          this.syncCircleProgress(progress);
        } else {
          this.style.setProperty('--progress-width', `${progress}%`);
        }
      }
    }

    syncCircleProgress(progress) {
      const circleEl = this.circleProgressElement;
      if (!circleEl) return;

      const circumference = parseFloat(getComputedStyle(this).getPropertyValue('--circle-circumference')) || 100;
      const dashArray = (progress / 100) * circumference;
      circleEl.style.strokeDasharray = `${dashArray} ${circumference}`;
    }

    startProgress() {
      const id = this.getAttribute('data-id');
      this.video = this.findVideo();

      if (this.video) {
        this.startVideoProgress();
      } else {
        this.startAnimationProgress();
      }
    }

    startAnimationProgress() {
      const id = this.getAttribute('data-id');
      this.classList.add('start-progress');

      if (this.isCircle) {
        const circleEl = this.circleProgressElement;
        if (circleEl) {
          const style = getComputedStyle(this);
          const duration = parseFloat(style.getPropertyValue('--duration')) || 10;
          const circumference = parseFloat(style.getPropertyValue('--circle-circumference')) || 100;
          
          let startTime = null;
          
          const animate = (timestamp) => {
            if (!startTime) startTime = timestamp;
            const elapsed = (timestamp - startTime) / 1000;
            const progress = Math.min(elapsed / duration, 1);
            
            const dashArray = progress * circumference;
            circleEl.style.strokeDasharray = `${dashArray} ${circumference}`;
            
            if (progress < 1) {
              this.animationFrame = requestAnimationFrame(animate);
            } else {
              this.stopProgress(true);
            }
          };
          
          this.animationFrame = requestAnimationFrame(animate);
        }
        return;
      }

      let handleAnimationEnd = () => {
        this.stopProgress(true);
        this.removeEventListener('animationend', handleAnimationEnd);
      };

      this.addEventListener('animationend', handleAnimationEnd);
    }

    startVideoProgress() {
      this.classList.add('video-sync');

      const videoEl = this.getVideoElement(this.video);
      if (!videoEl) {
        this.#waitForVideo();
        return;
      }

      this.#initVideoListeners(videoEl);

      if (!videoEl.paused) {
        this.classList.add('playing');
        this.#startVideoUpdate(videoEl);
      }
    }

    #waitForVideo() {
      const observer = new MutationObserver(() => {
        const videoEl = this.getVideoElement(this.video);
        if (videoEl) {
          observer.disconnect();
          this.#initVideoListeners(videoEl);
          if (!videoEl.paused) {
            this.classList.add('playing');
            this.#startVideoUpdate(videoEl);
          }
        }
      });
      observer.observe(this.video, { childList: true, subtree: true });
    }

    #initVideoListeners(videoEl) {
      if (this.#videoListenersAttached) return;
      this.#videoListenersAttached = true;

      videoEl.addEventListener('play', () => {
        this.classList.add('playing');
        this.#startVideoUpdate(videoEl);
      });

      videoEl.addEventListener('pause', () => {
        this.classList.remove('playing');
        this.#stopVideoUpdate();
      });

      videoEl.addEventListener('ended', () => {
        this.stopProgress(true);
      });

      videoEl.addEventListener('timeupdate', () => {
        this.syncWithVideo();
      });
    }

    #startVideoUpdate(videoEl) {
      this.#stopVideoUpdate();
      const updateProgress = () => {
        this.syncWithVideo();
        if (!videoEl.paused && !videoEl.ended) {
          this.animationFrame = requestAnimationFrame(updateProgress);
        }
      };
      updateProgress();
    }

    #stopVideoUpdate() {
      if (this.animationFrame) {
        cancelAnimationFrame(this.animationFrame);
      }
    }

    stopProgress(completed = false) {
      this.classList.remove('start-progress', 'playing', 'video-sync');

      if (this.animationFrame) {
        cancelAnimationFrame(this.animationFrame);
      }

      if (this.isCircle && !completed) {
        const circleEl = this.circleProgressElement;
        if (circleEl) {
          const circumference = parseFloat(getComputedStyle(this).getPropertyValue('--circle-circumference')) || 100;
          circleEl.style.strokeDasharray = `0 ${circumference}`;
        }
      }

      if (completed) {
        const id = this.getAttribute('data-id');
        document.dispatchEvent(new CustomEvent('YG:progress-end', {
          bubbles: true,
          composed: true,
          detail: { id }
        }));
      }
    }
  }

  if (!window.customElements.get('yg-progress-bar')) {
    window.customElements.define('yg-progress-bar', YGProgressBar);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["yg-tabs"] && !Shopify.designMode) return;
  try {
    class YGTabsTitle extends YGUtils {
      constructor() {
          super()
      }

      get sectionsEl() {
        if (this._sectionsEl) return this._sectionsEl;

        this._sectionsEl = {
          'title-list': Array.from(this.children),
          'content-list': Array.from(document.querySelector(`yg-tabs-content[data-id='${this.dataset.id}']`)?.children || [])
        };

        return this._sectionsEl;
      }

      connectedCallback() {
        this.initTabs()
        this.addEventListener('click', (e) => {
          let item = e.target.closest('.tab-title');
          if (item) {
            let i = this.sectionsEl['title-list'].indexOf(item);
            this.itemClick(item, i);
          }
        });
      }

      initTabs() {
        this.sectionsEl['title-list']?.forEach((el, i) => {
          if (!el.classList.contains('tab-title')) {
            el.classList.add('tab-title');
          }
          
          if (i == 0) {
            el.classList.add('is-active');
          }
        });
        this.updateStyle(this.sectionsEl['title-list'][0]);

        this.sectionsEl['content-list'].forEach((el, i) => {
          if (!el.classList.contains('tab-content')) {
            el.classList.add('tab-content');
          }

          if (i == 0)  el.classList.add('is-active');
        });
      }

      itemClick(el, i) {
        // 如果已经激活则直接返回
        if (el.classList.contains('is-active')) return;

        this.scrollItemIntoView(el);
        this.toggleClass(el, i)
      }

      scrollItemIntoView(el, options = {}) {
        const scrollContainer = this.closest('.yg-scroll-container');
        if (!scrollContainer || !el) return;

        const { behavior = 'smooth' } = options;
        const containerRect = scrollContainer.getBoundingClientRect();
        const itemRect = el.getBoundingClientRect();
        const currentScrollLeft = scrollContainer.scrollLeft;
        const rawScrollLeft = currentScrollLeft + (itemRect.left - containerRect.left) - ((scrollContainer.clientWidth - itemRect.width) / 2);
        const maxScrollLeft = Math.max(scrollContainer.scrollWidth - scrollContainer.clientWidth, 0);
        const nextScrollLeft = Math.min(Math.max(rawScrollLeft, 0), maxScrollLeft);

        if (typeof scrollContainer.scrollTo === 'function') {
          scrollContainer.scrollTo({
            left: nextScrollLeft,
            behavior
          });
          return;
        }

        scrollContainer.scrollLeft = nextScrollLeft;
      }

      toggleClass(el, i) {
        // 处理标题激活状态
        this.sectionsEl['title-list'].forEach((item) => {
          item.classList.remove('is-active');
        });
        el.classList.add('is-active');
        this.updateStyle(el);

        // 处理内容激活状态
        this.sectionsEl['content-list'].forEach((item) => {
          item.classList.remove('is-active');
        });
        if (this.sectionsEl['content-list'][i])
          this.sectionsEl['content-list'][i].classList.add('is-active');
      }

      updateStyle(el = null) {
        let itemEl = el || this.querySelector('.is-active');

        if (!itemEl) return;
        let left = itemEl.offsetLeft;
        let width = itemEl.offsetWidth;
        this.style.setProperty('--scroll-item-left', `${left}px`);
        this.style.setProperty('--scroll-item-width', `${width}px`);
      }
  }
  if (!window.customElements.get('yg-tabs-title')) {
      window.customElements.define('yg-tabs-title', YGTabsTitle)
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["yg-video"] && !Shopify.designMode) return;
  try {
    class YGVideo extends YGVideoLazyLoader {
    constructor() {
      super();
      this.playVideoClick = this.playVideo.bind(this);
      this.autoplay = this.getAttribute('data-autoplay');
      this.popup = this.getAttribute('data-popup');
      this.loop = this.getAttribute('data-loop');
      this.type = this.getAttribute('data-type');
      this.enablePause = this.getAttribute('data-enable-pause') === 'true';
    }

    get videoContainer() {
      return this.querySelector('.yg-video-iframe-container');
    }

    get image() {
      return this.querySelector('.yg-video-placeholder');
    }

    get template() {
      return this.querySelector('template');
    }

    get videoButton() {
      return this.querySelector('.yg-video-button');
    }

    get playVideoButton() {
      return this.querySelector('.yg-video-button .yg-play');
    }

    get pauseVideoButton() {
      return this.querySelector('.yg-video-button .yg-pause');
    }

    connectedCallback() {
      this.playVideoButton?.addEventListener('click', this.playVideoClick);
      this.pauseVideoButton?.addEventListener('click', ()=>this.pauseVideo());
      if (this.autoplay == 'true' && this.popup == 'false') {
        this.getLazyLoader().observe(this);
      }

      // Idle warmup for HTML5 <video> only (skip iframes) to improve first play without blocking main thread.
      this.scheduleHtml5VideoWarmup();
    }

    playVideo() {
      if (this.popup == 'true') {
        this.dispatchEvent(
          new CustomEvent('YG:openPopup', {
            bubbles: true,
            detail: {
              popupTemplate: this.template,
            },
          })
        );

        return;
      }

      this.image?.classList.add('close');
      this.switcherVideoButtonState("play")
      if (!this.videoContainer) {
        this.appendChild(this.template?.content.cloneNode(true));
      }

      if (this.type == 'video' && this.videoContainer) {
        let videos = this.videoContainer.querySelectorAll('.yg-video-iframe');

        this.videoContainer.classList.remove('close');
        videos.forEach(video => {
          video.play();
          // 监听video进度，当进度到达100%，且不循环时切换按钮
          video.addEventListener('timeupdate', () => {
            if (
              video.duration &&
              video.currentTime >= video.duration &&
              this.loop == 'false'
            ) {
              this.pauseVideo();
              this.switcherVideoButtonState("pause");
            }
          });
        });
      }

      
    }

    pauseVideo() {
      this.image?.classList.remove('close');
      this.switcherVideoButtonState("pause")
      
      if (this.type == 'video' && this.videoContainer) {
        let videos = this.videoContainer.querySelectorAll('.yg-video-iframe');
        if (!this.enablePause) {
          this.videoContainer.classList.add('close');
        }

        videos.forEach(video => {
          video.pause();
          if (!this.enablePause) {
            video.currentTime = 0;
          }
        });
      } else {
        this.videoContainer?.remove();
      }
    }

    switcherVideoButtonState (state = "play") {
      if (state == "pause") {
        if (!this.enablePause) {
          this.videoButton?.classList.remove('hide');
        } else {
          this.playVideoButton?.classList.remove('hide');
          this.pauseVideoButton?.classList.add('hide');
        }
        return;
      }
      if (state == "play") {
        if (!this.enablePause) {
          this.videoButton?.classList.add('hide');
        } else {
          this.playVideoButton?.classList.add('hide');
          this.pauseVideoButton?.classList.remove('hide');
        }
        return;
      }
    }

    scheduleHtml5VideoWarmup() {
      // Run once per element instance
      if (this.__ygHtml5WarmupScheduled) return;
      this.__ygHtml5WarmupScheduled = true;

      // Respect "Save-Data" users
      if (navigator?.connection?.saveData) return;

      const run = () => {
        try {
          const urls = this.getPreferredHtml5VideoUrls();
          urls.forEach((url) => this.warmupHtml5VideoUrl(url));
        } catch (e) {
          // Never break section rendering due to warmup.
        }
      };

      // Schedule work in idle time to avoid competing with main thread.
      if ('requestIdleCallback' in window) {
        window.requestIdleCallback(run, { timeout: 3000 });
      } else {
        window.setTimeout(run, 1200);
      }
    }

    getPreferredHtml5VideoUrls() {
      const isMobile = window.matchMedia && window.matchMedia('(max-width: 699px)').matches;

      // Prefer template content (when video is deferred) else DOM.
      const root = this.template?.content || this.videoContainer || this;

      // Only HTML5 <video> sources; explicitly skip iframe videos.
      const urls = [];

      // Prefer <source src> which is what Shopify video_tag usually outputs.
      const sources = root.querySelectorAll?.('video.yg-video-iframe source[src]') || [];
      sources.forEach((sourceEl) => {
        const videoEl = sourceEl.closest('video.yg-video-iframe');
        if (!videoEl) return;
        if (isMobile && videoEl.classList.contains('hide-pc')) return;
        if (!isMobile && videoEl.classList.contains('hide-mobile')) return;
        urls.push(sourceEl.getAttribute('src'));
      });

      // Fallback: <video src="...">
      const videos = root.querySelectorAll?.('video.yg-video-iframe[src]') || [];
      videos.forEach((videoEl) => {
        if (isMobile && videoEl.classList.contains('hide-pc')) return;
        if (!isMobile && videoEl.classList.contains('hide-mobile')) return;
        urls.push(videoEl.getAttribute('src'));
      });

      return [...new Set(urls.filter(Boolean))].filter((u) => !u.startsWith('blob:'));
    }

    warmupHtml5VideoUrl(url) {
      if (!url) return;

      // De-dupe across the whole page
      window.__ygWarmupVideoUrls ||= new Set();
      if (window.__ygWarmupVideoUrls.has(url)) return;
      window.__ygWarmupVideoUrls.add(url);

      // Hint preload (low priority where supported)
      try {
        const link = document.createElement('link');
        link.rel = 'preload';
        link.as = 'video';
        link.href = url;
        link.crossOrigin = 'anonymous';
        // Some Chromium builds support this; safe elsewhere.
        link.fetchPriority = 'low';
        document.head.appendChild(link);
      } catch (e) {}

      // Prime HTTP cache with a small Range request (best-effort). Only for same-origin / Shopify CDN to avoid CORS surprises.
      try {
        const u = new URL(url, window.location.href);
        const isSameOrigin = u.origin === window.location.origin;
        const isShopifyCdn = u.hostname.endsWith('cdn.shopify.com');
        if (!isSameOrigin && !isShopifyCdn) return;

        const controller = new AbortController();
        const timeoutId = window.setTimeout(() => controller.abort(), 4000);

        fetch(u.toString(), {
          method: 'GET',
          mode: 'cors',
          credentials: 'omit',
          cache: 'force-cache',
          headers: {
            Range: 'bytes=0-1048575',
          },
          signal: controller.signal,
        })
          .catch(() => {})
          .finally(() => window.clearTimeout(timeoutId));
      } catch (e) {}
    }

  }
  document.addEventListener('DOMContentLoaded', () => {
    if (!window.customElements.get('yg-video')) {
      window.customElements.define('yg-video', YGVideo);
    }
  });
  } catch(e) { console.error(e); }
})();

})();
